import { 
  SUPABASE_URL,
  STRIPE_PUBLISHABLE_KEY,
  STRIPE_BASIC_PLAN_PRICE_ID,
  STRIPE_STANDARD_PLAN_PRICE_ID,
  STRIPE_PROFESSIONAL_PLAN_PRICE_ID,
  STRIPE_ENTERPRISE_PLAN_PRICE_ID,
  STRIPE_CREDIT_PACK_500_PRICE_ID,
  STRIPE_CREDIT_PACK_1000_PRICE_ID
} from '../constants';

export const STRIPE_CONFIG = {
  currency: 'jpy',
  publishableKey: STRIPE_PUBLISHABLE_KEY,
  endpoints: {
    createPaymentIntent: `${SUPABASE_URL}/functions/v1/create-payment-intent`,
    createSubscription: `${SUPABASE_URL}/functions/v1/create-subscription`,
    cancelSubscription: `${SUPABASE_URL}/functions/v1/cancel-subscription`,
    createCustomerPortal: `${SUPABASE_URL}/functions/v1/create-customer-portal`
  }
};

// Subscription plans configuration
export const SUBSCRIPTION_PLANS = [
  {
    id: 'unsubscribed',
    name: '未加入',
    description: '無料プラン',
    price: 0,
    currency: 'jpy',
    interval: 'month',
    aiLimit: 10,
    productLimit: 30,
    features: [
      '基本機能',
      'AIタイトル生成 月10回まで',
      'テンプレート保存 3件まで',
      'メールサポート'
    ],
    priceId: ''
  },
  {
    id: 'basic',
    name: 'ベーシック',
    description: '個人利用に最適なプラン',
    price: 2980,
    currency: 'jpy',
    interval: 'month',
    aiLimit: 200,
    productLimit: 200,
    features: [
      '基本機能',
      'AIタイトル生成 月200回まで',
      // 'テンプレート保存 5件まで',
      // 'メールサポート'
    ],
    priceId: STRIPE_BASIC_PLAN_PRICE_ID
  },
  {
    id: 'standard',
    name: 'スタンダード',
    description: '小規模ビジネス向けプラン',
    price: 4980,
    currency: 'jpy',
    interval: 'month',
    aiLimit: 800,
    productLimit: 1000,
    features: [
      '基本機能',
      'AIタイトル生成 月800回まで',
      // 'テンプレート保存 無制限',
      // '優先メールサポート',
      'CSVインポート/エクスポート'
    ],
    priceId: STRIPE_STANDARD_PLAN_PRICE_ID
  },
  {
    id: 'professional',
    name: 'プロフェッショナル',
    description: '中規模ビジネス向けプラン',
    price: 9800,
    currency: 'jpy',
    interval: 'month',
    aiLimit: 2000,
    productLimit: 3000,
    features: [
      '基本機能',
      'AIタイトル生成 月2,000回まで',
      // 'テンプレート保存 無制限',
      // '優先メールサポート',
      'CSVインポート/エクスポート',
      // 'API連携',
      // '複数アカウント (3ユーザーまで)'
    ],
    priceId: STRIPE_PROFESSIONAL_PLAN_PRICE_ID
  },
  {
    id: 'enterprise',
    name: 'エンタープライズ',
    description: '大規模ビジネス向けプラン',
    price: 14800,
    currency: 'jpy',
    interval: 'month',
    aiLimit: 4000,
    productLimit: 10000,
    features: [
      '基本機能',
      'AIタイトル生成 月4,000回まで',
      // 'テンプレート保存 無制限',
      // '24時間サポート',
      'CSVインポート/エクスポート',
      // 'API連携',
      // '複数アカウント (10ユーザーまで)',
      // 'カスタム機能開発'
    ],
    priceId: STRIPE_ENTERPRISE_PLAN_PRICE_ID
  }
];


export interface ICreditPack {
  credits: number;
  amount: number;
  priceId: string;
}

export const CREDIT_PACKS: ICreditPack[] = [
  { credits: 500, amount: 2980, priceId: STRIPE_CREDIT_PACK_500_PRICE_ID },
  { credits: 1000, amount: 4980, priceId: STRIPE_CREDIT_PACK_1000_PRICE_ID }
];